/**
 * Minimal synchronous event bus.
 *
 * The pattern trainer, the LSO grader, the HUD and the DOM panels all want to
 * know when the same things happen (touchdown, bolter, phase change) without
 * knowing about each other. This is 30 lines instead of a dependency.
 */
export class EventBus {
  constructor() {
    /** @type {Map<string, Set<Function>>} */
    this.listeners = new Map()
  }

  on(type, fn) {
    if (!this.listeners.has(type)) this.listeners.set(type, new Set())
    this.listeners.get(type).add(fn)
    return () => this.off(type, fn)
  }

  once(type, fn) {
    const off = this.on(type, (...args) => {
      off()
      fn(...args)
    })
    return off
  }

  off(type, fn) {
    this.listeners.get(type)?.delete(fn)
  }

  emit(type, payload) {
    const set = this.listeners.get(type)
    if (!set) return
    for (const fn of set) {
      try {
        fn(payload)
      } catch (err) {
        console.error(`[EventBus] listener for "${type}" threw:`, err)
      }
    }
  }

  clear() {
    this.listeners.clear()
  }
}

export const bus = new EventBus()
